import { type RouteRecordRaw } from "vue-router";
import { canAccess, haveOneAccess, permissionList } from "@/utilities/authorization";

const productRoutes: RouteRecordRaw[] = [
    {
        name: 'product-navigation',
        path: '/product/navigation',
        component: () => import('@/views/product/ProductNavigation.vue'),
        beforeEnter: () => haveOneAccess([permissionList.READ_PRODUCT, permissionList.CREATE_PRODUCT]) ? true : { name: 'dashboard' },
    },
    {
        name: 'product',
        path: '/product',
        component: () => import('@/views/product/ProductIndex.vue'),
        beforeEnter: () => canAccess(permissionList.READ_PRODUCT) ? true : { name: 'product-navigation' },
    },
    {
        name: 'product-detail',
        path: '/product/:id(\\d+)',
        component: () => import('@/views/product/DetailProduct.vue'),
        beforeEnter: () => canAccess(permissionList.READ_PRODUCT) ? true : { name: 'product-navigation' },
    },
    {
        name: 'product-new',
        path: '/product/new',
        component: () => import('@/views/product/NewProduct.vue'),
        beforeEnter: () => canAccess(permissionList.CREATE_PRODUCT) ? true : { name: 'product-navigation' },
    },
    {
        name: 'product-update',
        path: '/product/update/:id(\\d+)',
        component: () => import('@/views/product/UpdateProduct.vue'),
        beforeEnter: () => canAccess(permissionList.UPDATE_PRODUCT) ? true : { name: 'product-navigation' },
    },
]

export default productRoutes
